import React from 'react';
import { useSelector } from 'store';

function TalkBot() {
    const { talkIsShow } = useSelector((state) => state.loadingCursor);
    return (
        <React.Fragment>
            <div className={`chat-bot ${talkIsShow ? 'active': ''}`}>
                <div className="content-loading">
                    <div className="chat-bot-text">
                        <div className="child">
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                            <div className="wave" />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default TalkBot;
